import { useEffect, useState } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { api } from "@/lib/api";
import { useCurrency } from "@/lib/CurrencyProvider";
import { MessageCircle, ShoppingBag } from "lucide-react";

const WA = "2348139771270";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");
  const { format } = useCurrency();

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);

  const cats = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const filtered = filter === "All" ? products : products.filter((p) => p.category === filter);

  const orderLink = (p) => `https://wa.me/${WA}?text=${encodeURIComponent(`Hello Dr. Juwon, I'd like to order: ${p.name} (${p.price_display || format(p.price)}).`)}`;

  return (
    <div className="min-h-screen ankara" data-testid="shop-page">
      <Header />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-10">
        <div className="chip chip-terra mb-3">Pet Shop</div>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05]">Everything your pet needs — <span className="italic text-[#C2410C]">delivered with care.</span></h1>
        <p className="mt-4 max-w-2xl text-[#57534E]">Food, supplements, grooming, tick &amp; flea, accessories. Order via WhatsApp for now; online checkout coming soon.</p>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="shop-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => setFilter(c)} data-testid={`prod-filter-${c}`}
              className={`px-4 py-2 rounded-full text-xs font-semibold border transition-colors ${filter === c ? "bg-[#C2410C] text-white border-[#C2410C]" : "bg-white text-[#1C1917] border-[#EAD9B0] hover:border-[#C2410C]"}`}>{c}</button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {filtered.map((p) => (
            <div key={p.product_id} className="card-lift bg-white border border-[#EAD9B0] rounded-2xl overflow-hidden" data-testid={`product-${p.product_id}`}>
              <div className="aspect-square bg-white flex items-center justify-center overflow-hidden">
                {p.image_url ? <img src={p.image_url} alt={p.name} className="w-full h-full object-contain" /> : <ShoppingBag size={40} className="text-[#0F766E]" />}
              </div>
              <div className="p-4">
                <div className="text-[10px] uppercase tracking-widest text-[#C2410C]">{p.category}</div>
                <div className="font-display text-base mt-1 line-clamp-2">{p.name}</div>
                <div className="mt-2 flex items-center justify-between">
                  <span className="font-semibold text-[#0F766E]">{p.price_display || format(p.price)}</span>
                  {p.stock > 0 ? <span className="text-[10px] text-[#57534E]">{p.stock} in stock</span> : <span className="text-[10px] text-[#C2410C]">Sold out</span>}
                </div>
                <a href={orderLink(p)} target="_blank" rel="noopener noreferrer"
                  className="mt-3 block text-center btn-whatsapp py-2 rounded-full text-xs font-semibold inline-flex items-center justify-center gap-1"
                  data-testid={`order-${p.product_id}`}>
                  <MessageCircle size={12} /> Order via WhatsApp
                </a>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <p className="col-span-full text-center text-[#57534E] py-12">No products in this category yet.</p>}
        </div>
      </section>
      <Footer />
    </div>
  );
}
